import React from 'react';

/**
 * CourtPlanLogo — single source of truth for the COURT/PLAN brand mark.
 * Visual reference: LandingPage hero logo (text-4xl md:text-5xl).
 * The "PLAN" half is rendered inside a red-700 pill, with a scaleX(1.15)
 * transform and a monospace font family. Use the `size` prop to render
 * smaller variants (e.g., dashboard header) while preserving proportions.
 */
const SIZES = {
  // Used on Login page card
  md: {
    container: 'text-3xl md:text-4xl font-bold tracking-tight text-slate-900 inline-flex items-center justify-center',
    plan: 'text-white font-bold bg-red-700 px-3 py-1.5 rounded-xl inline-flex items-center justify-center ml-3 leading-none',
    planStyle: { letterSpacing: '-0.02em', transform: 'scaleX(1.15)', fontFamily: 'ui-monospace, SFMono-Regular, "SF Mono", Menlo, Monaco, Consolas, monospace' },
  },
  // Used on Landing hero
  hero: {
    container: 'text-4xl md:text-5xl font-bold tracking-tight text-slate-900 inline-flex items-center justify-center',
    plan: 'text-white font-bold bg-red-700 px-4 py-2 rounded-xl inline-flex items-center justify-center ml-4 leading-none',
    planStyle: { letterSpacing: '-0.02em', transform: 'scaleX(1.15)', fontFamily: 'ui-monospace, SFMono-Regular, "SF Mono", Menlo, Monaco, Consolas, monospace' },
  },
  // Used on Dashboard header (compact) — identical visual on mobile & desktop
  sm: {
    container: 'text-2xl font-bold tracking-tight text-slate-900 inline-flex items-center justify-center',
    plan: 'text-white font-bold bg-red-700 px-2 py-1 rounded-lg inline-flex items-center justify-center ml-2 leading-none',
    planStyle: { letterSpacing: '-0.02em', transform: 'scaleX(1.15)', fontFamily: 'ui-monospace, SFMono-Regular, "SF Mono", Menlo, Monaco, Consolas, monospace' },
  },
};

const CourtPlanLogo = ({ size = 'hero', className = '' }) => {
  const cfg = SIZES[size] || SIZES.hero;
  return (
    <h2 className={`${cfg.container} ${className}`} data-testid="courtplan-logo">
      <span className="tracking-widest">COURT</span>
      <span className={cfg.plan} style={cfg.planStyle}>
        PLAN
      </span>
    </h2>
  );
};

export default CourtPlanLogo;
